import { Box, List, ListItem, ListItemText, Stack, Typography, alpha } from "@mui/material";
import { UMargin, UMarginBottom, URow, USection, USticky } from "../common/ui.page";
import { CPage, CPageTitle, CPageTop, CSection } from "../components/cr.ui.page";
import { CUnitList, CMainField } from "../components/cr.ui.order";
import { UIcon } from "../common/ui.icon";
import { useOrder } from "../components/order";
import { ERROR_COLOR, GREY, SECONDARY_COLOR, WARN_COLOR, WHITE } from "../style/theme";
import { UButton } from "../common/ui.buttons";
import { Add } from "@mui/icons-material";
import { PageContext } from "../common/pages";
import { UEditableTextField } from "../common/ui.editable";
import { CPayButton } from "../components/cr.ui.requisition";
import { useCrusade } from "../components/crusade";
import { CExtPlayerCrusadeTop } from "../components/cr.ext";
import { useExt } from "../components/ext";

export function PageOrderMain(props) {
    const order = useOrder()
    return <CPage>
        <CPageTop
            alert={order.matchToJoin.length}
            codex={order.codex.name}
            primary={order.player.name}
            secondary="Ordine di Battaglia" />
        <Stack spacing={2}>

            <CSection sx={{ paddingTop: 1 }}>
                <MainTitle />
            </CSection>

            <CSection>
                <OrderStats />
            </CSection>

            <CSection>
                <CrusadeForce />

            </CSection>

            <USection>
                <UMargin>
                    <CrusadePay />
                </UMargin>
            </USection>

            <CrusadeCtrl />
        </Stack>

    </CPage>
}

function MainTitle() {
    const ext = useExt()

    return <Stack >
        <CExtPlayerCrusadeTop />


        {ext.playerTitle()}

    </Stack>


}

function OrderStats() {
    const order = useOrder()
    return <Stack spacing={2}>
        <OrderWarnings />
        <Stack direction="row" justifyContent="space-between" >
            <CMainField title="Partite giocate">{order.player.games}</CMainField>
            <CMainField title="Vittorie">{order.player.wins}</CMainField>
            <CMainField color={order.rp > 5 ? WARN_COLOR : ''} title="Requisizioni">{order.rp}</CMainField>
        </Stack>
    </Stack>
}
function OrderWarnings() {
    const order = useOrder()
    if (order.warnings.length == 0) {
        return <></>
    }

    return <List sx={{ background: alpha(WARN_COLOR, 0.2) }}>
        {order.warnings.map(w => <ListItem key={w}>
            <Typography sx={{ color: WARN_COLOR }}>
                {w}
            </Typography>
        </ListItem>)}
    </List>

}

function MessageNoUnits() {

    return <Stack
        justifyContent="center"
        sx={{
            border: '4px dashed ' + GREY[500],
            padding: 4,
            textAlign: 'center',
            color: GREY[500]
        }}>
        <Typography sx={{ fontSize: 20 }}>
            Aggiunti unità per comporre la tua Forza Crociata
        </Typography>
    </Stack>
}

function CrusadeForce(props) {
    const order = useOrder()

    return <Stack>
        <Typography sx={{ color: GREY[700], fontSize: 16, fontWeight: 600 }}>Forza Crociata</Typography>
        {order.units.length > 0 ? <CUnitList
            limit={order.limit}
            units={order.units}
            sx={{ marginY: 2 }} /> : <UMargin><MessageNoUnits /></UMargin>}

        <UButton page="unit/new" variant="contained" endIcon={<Add />}>Nuova unità</UButton>
    </Stack>
}

function CrusadePay(props) {
    const order = useOrder()
    return <Stack spacing={2}>
        <CPayButton type="limit.increase" onComplete={order.reload} />
    </Stack>
}

function CrusadeCtrl(props) {
    const order = useOrder()

    return <Stack sx={{ paddingTop: 10 }}>


        <UButton
            call="player/reset"
            onCall={order.reload}
            confirm="Attenzione! Stai per cancellare questa crociata! Tutti i dati saranno perduti e dovrai ricominciare la campagna dall'inizio!"
            color="warning">Cancella crociata</UButton>
    </Stack>
}